import template from './FiltersPanel.html';

export default {
	template,
	data() {
		return {
			legacy: false,
			expanded: false,
			persistentFilters: ['dates', 'domain', 'page', 'source', 'bots']
		};
	},
	computed: {
		filters() {
			let items = Object.keys(this.filtersMap)
				.map(key => this.filtersMap[key])
				.filter(this.shouldDisplayItem);

			return items;
		},
		segmentItems() {
			let items = (this.app.segments || []).map(s => {
				return {
					id: s.id,
					text: s.name,
					url: '?' + s.query
				};
			});

			items.push({
				icon: 'save',
				text: this.ii('SAVE')
			});

			return items;
		}
	},
	methods: {
		shouldDisplayItem(it) {
			if (!it || it.disabled) return false;
			if (this.persistentFilters.indexOf(it.key) !== -1) return true;
			if (this.expanded && !it.hidden) return true;
			if (this.app.query[it.key]) return true;
			return false;
		},
		checkEmpty(item) {
			if (this.persistentFilters.indexOf(item.key) !== -1) return false;
			return !this.app.query[item.key];
		},
		getFormattedVal(key) {
			let val = this.app.query[key] || '';
			let filter = this.filtersMap[key];
			if (!filter) return val;

			let prefix = '';
			if (filter.key === 'bots') {
				val = this.botsItemsMap[val];
			} else if (filter.type === 'multisel') {
				if (val.indexOf('n_') === 0) {
					val = val.slice(2);
					prefix = this.ii('NOT') + ' ';
				}
				val = val.split(',').map(it => {
					if (key === 'geo') return this.getCountryByCode(it);
					if (key === 'lang') return this.getLanguageByCode(it);
					if (key === 'source') return this.ii(it);
					return it;
				}).join(', ');
			} else if (filter.type === 'lists') {
				let lists = {white: [], black: []};
				val.split('|').forEach(part => {
					let key = 'white';
					if (part.indexOf('n_') === 0) {
						key = 'black';
						part = part.slice(2);
					}
					part.split(',').forEach(it => {
						if (it) {
							lists[key].push(it);
						}
					});
				});
				let parts = [];
				if (lists.white.length) {
					parts.push(lists.white.join(', '));
				}
				if (lists.black.length) {
					parts.push(this.ii('NOT') + ' ' + lists.black.join(', '));
				}
				val = parts.join(' ');
			} else if (filter.type === 'dateRange') {
				let val = this.app.query[key] || '';
				let range = this.parseDateRange(val);
				let startDate = range.from;
				let endDate = range.to;

				if (!startDate) return;

				if (range.format === 'month') {
					return moment.tz(val, this.app.tz).format('MMMM YYYY');
				}

				let todayMoment = moment().tz(this.app.tz);
				let today = todayMoment.format('YYYY-MM-DD');

				if (startDate === endDate) {
					if (endDate === today) return this.ii('TODAY');
					let daysAgo = moment().tz(this.app.tz).diff(moment.tz(endDate, this.app.tz), 'days');
					if (daysAgo === 1) return this.ii('YESTERDAY');
					return this.iiArgs('N_DAYS_AGO', daysAgo);
				}

				if (endDate === today) {
					let days = todayMoment.diff(moment.tz(startDate, this.app.tz), 'days') + 1;
					return this.iiArgs('LAST_N_DAYS', days);
				}

				let from = moment.tz(startDate, this.app.tz).format('MMM D, YYYY');
				let to = moment.tz(endDate, this.app.tz).format('MMM D, YYYY');
				return `${from} - ${to}`;
			} else if (filter.type === 'domain') {
				if (!val) return val;

				if (val.indexOf('@') === 0) return val.slice(1);
				if (val.indexOf('base_') === 0) return val.replace('base_', '').replace(/,/g, ', ');
				return val.replace(/(^|,)/g, '$1 *.');
			}

			return prefix + val;
		},
		onFilterChange(itemKey) {
			let panel = this.$refs['filterPanel_' + itemKey][0];
			panel && panel.close && panel.close();
		},
		onSegmentClick(item) {
			this.$refs.segmentsDropPanel.close();
		},
		async addSegment() {
			let name = await this.prompt(this.ii('ENTER_SEGMENT_NAME'));
			if (name === null) return;
			if (!name) return this.alert(this.ii('SEGMENT_NAME_CANNOT_BE_EMPTY'));

			let query = location.search.replace(/^\?/, '');
			try {
				await this.http.post('Auth.addSegment', name, query)
			} catch (err) {
				return this.handleSegmentError(err);
			}

			this.$refs.segmentsDropPanel.close();
			this.app.loadSegments();
		},
		async editSegment(item) {
			let name = await this.prompt(this.ii('ENTER_SEGMENT_NEW_NAME'), item.text);
			if (name === null) return;
			if (!name) return this.alert(this.ii('SEGMENT_NAME_CANNOT_BE_EMPTY'));

			try {
				await this.http.post('Auth.editSegment', item.id, name);
			} catch (err) {
				return this.handleSegmentError(err);
			}

			this.app.loadSegments();
		},
		async removeSegment(item) {
			let ok = await this.confirm(this.iiArgs('REMOVE_SEGMENT_N_QST', item.text));
			if (!ok) return;

			await this.http.post('Auth.removeSegment', item.id);
			this.app.loadSegments();
		},
		onRemoveClick(e, item) {
			e.preventDefault();
			e.stopPropagation();

			let params = {};
			params[item.key] = undefined;
			this.editQueryParams(params);
		}
	},
	mounted() {
		if (this.app.query.old) {
			this.legacy = true;
		}
	}
};